<template>
  <div class="index-service">
    <div class="container-md">
      <div class="service-title">一站式智能签证办理体验</div>
      <div class="service-list">
        <div class="service-item" v-for="item in serviceList" :key="item.title">
          <img class="item-img" :src="item.img" alt="">
          <div class="item-title">{{item.title}}</div>
          <div class="item-desc" v-html="item.desc"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'index-service',
  data() {
    return {
      serviceList: [
        {
          img: 'https://o.666visa.cn/static/ssqpeer/homepage/service-1.png',
          title: '资料扫描，自动填表',
          desc: '先进的OCR文字识别技术<br/>智能提取护照、身份证信息<br/>自动填写签证申请表',
        },
        {
          img: 'https://o.666visa.cn/static/ssqpeer/homepage/service-2.png',
          title: '手机拍摄签证照片',
          desc: '抠图、美颜、换背景<br/>一键在线搞定',
        },
        {
          img: 'https://o.666visa.cn/static/ssqpeer/homepage/service-3.png',
          title: '一次上传，永久复用',
          desc: '一键资料转发，顾客可自行填写上传<br/>全部资料电子化保存云端<br/>AES加密技术，保障数据安全',
        },
        {
          img: 'https://o.666visa.cn/static/ssqpeer/homepage/service-4.png',
          title: '办理进程透明，重要信息提醒',
          desc: '实时跟踪订单审核、出签等环节<br/>重要通知微信、短信同步更新推送',
        },
        {
          img: 'https://o.666visa.cn/static/ssqpeer/homepage/service-5.png',
          title: '一对一专家服务',
          desc: '  从业十年资深签证专家一对一服务<br/>7*12小时随时响应',
        },
        {
          img: 'https://o.666visa.cn/static/ssqpeer/homepage/service-6.png',
          title: '纸质资料提交，顺丰双向物流',
          desc: '需要递交领馆的纸质资料<br/>顺丰双向快递上门取送<br/>省时省心，实时进度',
        },
      ],
    };
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.index-service{
  padding: 20px 0 24px 0;
  .service-title{
    text-align: center;
    color: #2F333D;
    font-size: 32px;
    line-height: 1;
    font-weight: 500;
    position: relative;
    z-index: 1;
    &::after{
      content: "";
      width:140px;
      height:8px;
      background:linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,0.8) 50%,rgba(89,159,255,0) 100%);
      opacity:0.8;
      position: absolute;
      bottom: -4px;
      left: 50%;
      transform: translateX(-50%);
      z-index: -1;
    }
  }
  .service-list{
    margin-top: 30px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .service-item{
      width: 353px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      padding: 16px 28px 68px 28px;
      position: relative;
      z-index: 1;
      margin-bottom: 14px;
      &::after{
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 80px;
        bottom: 0;
        z-index: -1;
        background:#F9FBFF;
      }
      .item-img{
        width: 121px;
        height: 121px;
      }
      .item-title{
        margin-top: 12px;
        font-size: 18px;
        color: #2F333D;
        font-weight: 600;
        line-height: 28wpx;
      }
      .item-desc{
        text-align: center;
        color: #666666;
        font-size: 16px;
        line-height: 28px;
        margin-top: 12px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/index/components/index-service.vue